import React, { useContext } from 'react'
import { func } from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { productDataType } from 'models/propTypes'
import ProductItemDetail from 'components/designSidepanel/ProductItemDetail'
import ProductItemImage from 'components/designSidepanel/ProductItemImage'
import Icon from 'components/uiElements/Icon'
import arrowCounterclockwise from '@ingka/ssr-icon/paths/arrow-counterclockwise'

import SugarcubeContext from 'apps/SugarcubeContext'
import Button from '@ingka/button'

require('./ProductItem.scss')

const ProductItemInSwap = ({ swappableItemData, onSelect, onSwap, selectedFurnitureData, viewDetails, onUndoSwap }) => {
    const { t } = useTranslation()
    const isSelected = swappableItemData.id === selectedFurnitureData.id
    const { name, price, thumbUrl, description } = swappableItemData

    const { isMobile } = useContext(SugarcubeContext)
    const threeColumns = !isMobile
    const onDetailsClick = isMobile || isSelected ? null : viewDetails
    const swapButtonAriaLabel = `${t('design.swap')} ${name} ${description}`
    const viewDetailsAriaLabel = `${t('aria.product details')} ${name} ${description}`
    return (
        <div className={classNames('ProductItem ProductItemInSwap', { threeColumns, isSelected, mobile: isMobile })}>
            {isMobile && (
                <div className="itemImageContainerMobile">
                    <button className="infoButton" onClick={viewDetails} aria-label={viewDetailsAriaLabel}>
                        <Icon code="info_circle" svg />
                    </button>
                    <button
                        className="swapButton mobile"
                        onClick={onSwap}
                        data-testid="product-item-image-btn"
                        aria-label={swapButtonAriaLabel}
                    >
                        <div>
                            <div className={classNames('selectedTag', { isSelected, mobile: isMobile })} />
                        </div>
                        <ProductItemImage thumbUrl={thumbUrl} name={name} isInMyItems={false} isInSwap />
                    </button>
                </div>
            )}
            {!isMobile && (
                <div
                    className={classNames('itemImageContainer', { isSelected })}
                    onClick={isSelected ? null : onSelect}
                    data-img-title={t('tooltip.swap product')}
                >
                    <button
                        className="swapButton"
                        onClick={isSelected ? null : onSwap}
                        data-testid="product-item-image-btn"
                        aria-label={swapButtonAriaLabel}
                    >
                        <ProductItemImage thumbUrl={thumbUrl} name={name} isInSwap showIcon />
                    </button>
                </div>
            )}
            <div className={classNames('itemDetailContainer', { mobile: isMobile })} onClick={onDetailsClick}>
                {isSelected ? (
                    <div className="swappedDetails">
                        <div className="swappedText">{t('design.product swapped')}</div>
                        <Button
                            onClick={onUndoSwap}
                            type="secondary"
                            text={t('design.undo')}
                            small
                            ssrIcon={arrowCounterclockwise}
                        />
                    </div>
                ) : (
                    <ProductItemDetail name={name} price={price} description={description} isInSwap />
                )}
            </div>
        </div>
    )
}
ProductItemInSwap.propTypes = {
    swappableItemData: productDataType.isRequired,
    onSelect: func.isRequired,
    onSwap: func.isRequired,
    selectedFurnitureData: productDataType.isRequired,
    viewDetails: func.isRequired,
    onUndoSwap: func.isRequired,
}

export default ProductItemInSwap
